<template>
  <div class="about-container">
    <div class="right">
      <h1>من هو - م/ محمد طارق</h1>
      <p>
        الأستاذ محمد طارق، المعروف بلقب "قيصر اللغة العربية"، هو مدرس مميز لمادة
        اللغة العربية في المرحلة الثانوية. يقدم محتوى تعليمياً شاملاً يتضمن
        شرحاً وافيًا لجميع أجزاء المادة، بما في ذلك النحو، البلاغة، الأدب،
        والنصوص، مستعينًا بأسلوب سهل ومباشر لجعل المادة ممتعة ومفهومة للطلاب.
        يعتمد الأستاذ محمد طارق على دمج التعليم مع التشجيع النفسي، حيث يحث
        الطلاب على الاجتهاد والتفاؤل، كما يشارك قصصًا مؤثرة تحفزهم على المثابرة،
        مثل قصة طالبة حققت نجاحًا بالرغم من تحدياتها الشخصية، مما يبرز التزامه
        ليس فقط بالتعليم بل بتطوير شخصية الطالب أيضًا. إلى جانب ذلك، يوفر
        الأستاذ محمد طارق مجموعة من المراجعات المكثفة والأسئلة التطبيقية عبر
        قناته على يوتيوب وموقعه الرسمي، مع توفير مصادر إضافية لمساعدات دراسية
        مثل الملازم والدروس المصورة.
      </p>
    </div>
    <div class="left">
      <img src="../../assets/banner-bg.jpg" alt="م/ محمد طارق" />
      <div class="social-media">
        <a
          href="https://www.youtube.com/@Mr.Mohamed_Tarek"
          target="_blank"
          rel="noopener noreferrer"
          class="youtube"
        >
          <PhFillYoutubeLogo />
          <span>Youtube</span>
        </a>
        <a
          href="https://www.facebook.com/mr.mtarek"
          target="_blank"
          rel="noopener noreferrer"
          class="facebook"
        >
          <PhFillFacebookLogo />
          <span>Facebook</span>
        </a>
        <a
          href="https://www.instagram.com/mr.mtarek"
          target="_blank"
          rel="noopener noreferrer"
          class="instagram"
        >
          <PhFillInstagramLogo />
          <span>Instagram</span>
        </a>
        <a href="https://www.tiktok.com/@mr.mtarek" class="tiktok">
          <PhFillTiktokLogo />
          <span>Tiktok</span>
        </a>
        <a href="https://t.me/+2lHtSpur2aI5MTM8" class="telegram">
          <PhFillTelegramLogo />
          <span>Telegram</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {
  PhFillYoutubeLogo,
  PhFillFacebookLogo,
  PhFillInstagramLogo,
  PhFillTiktokLogo,
  PhFillTelegramLogo,
} from "@kalimahapps/vue-icons";
export default {
  name: "AboutComponent",
  components: {
    PhFillYoutubeLogo,
    PhFillFacebookLogo,
    PhFillInstagramLogo,
    PhFillTiktokLogo,
    PhFillTelegramLogo,
  },
};
</script>

<style scoped>
.about-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: calc(100vh - 100px);
}
.about-container .right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 50%;
  height: 100%;
  padding: 0 2rem;
}
.about-container .right h1 {
  font-size: 2.25rem;
  font-weight: 500;
  color: #0c0c0c;
}
.about-container .right p {
  font-size: 1.25rem;
  font-weight: 500;
  color: #0c0c0c;
}
body.dark .about-container .right h1,
body.dark .about-container .right p {
  color: #dad2c5b2;
}
.about-container .left {
  width: 40%;
  height: 100%;
  background-image: url("../../assets/banner-bg.jpg");
  background-size: cover;
  background-position: 20%;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.about-container .left img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
  z-index: 1;
  display: none;
}
.about-container .left .social-media {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
  background-color: #2b423933;
  backdrop-filter: blur(50px);
  border-radius: 5.75rem;
  z-index: 2;
}
.about-container .left .social-media a {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 0.25rem;
  text-decoration: none;
}
.about-container .left .social-media a svg {
  color: #ffffff;
  font-size: 1.5rem;
}
.about-container .left .social-media a span {
  font-size: 1rem;
  font-weight: 500;
  color: #ffffff;
  font-family: Qatar2022 Arabic;
  font-weight: 700;
  display: none;
}
.about-container .left .social-media a:hover span {
  display: block;
}
@media (max-width: 992px) {
  .about-container {
    flex-direction: column;
    gap: 2rem;
    height: auto;
  }
  .about-container .right,
  .about-container .left {
    width: 100%;
  }
  .about-container .left img {
    display: block;
  }
}
</style>
